
import './App.scss';
import Contact from './components/Contact';
import Header from './components/Header';
import Portfolio from './components/Portfolio';
import Resume from './components/Resume';
import Service from './components/Service';



function App() {
  return (
   <>
    <Header/>
    <Service/>
    <Resume/>
    <Portfolio/>
    <Contact/>
    
   </>
  );
}

export default App;
